import React from "react";
import { Layout } from "../../layouts/Layout";
import { useTranslation } from "react-i18next";
import { ServiceFive } from "../../components/Services/ServiceFive";

const ServicesPage = () => {
  const { t } = useTranslation();
  return (
    <Layout footer={2} breadcrumb={t("pages.services.breadcrumb")} title={t("pages.services.title")} >
      {/* services */}
      <ServiceFive />
    </Layout>
  );
};

export default ServicesPage;
